<template>
  <a-modal
    :visible="visible"
    @cancel="closeModal"
    :footer="null"
    :class="['view-feed-modal', { 'link-only-modal': viewFeed?.content_type !== 'image' && viewFeed?.content_type !== 'video' && viewFeed?.content_type !== 'article' && (viewFeed?.content_type !== 'share' || viewFeed?.content_type === 'share' && isSharedContentTypeText) }]"
    :title="null"
  >
    <div class="view-feed-modal-container">
      <a-row :gutter="[0, 0]">
        <a-col :xs="24" :sm="24" :md="14" :lg="15" :xl="15" v-if="viewFeed?.content_type === 'image' || viewFeed?.content_type === 'video' || viewFeed?.content_type === 'article' || viewFeed?.content_type === 'share' && !isSharedContentTypeText">
          <div class="view-feed-modal-container__left-container">
            <!-- If fileUrl is an image, display it inside the img tag -->
            <div
              class="view-feed-modal-container__left-container--media"
              v-if="
                viewFeed?.content_type === 'image' ||
                  viewFeed?.content_type === 'video'
              "
            >
              <img
                :src="fileUrl"
                alt="Image"
                v-if="viewFeed?.content_type === 'image'"
              />
              <video
                width="320"
                height="240"
                controls
                v-else-if="viewFeed?.content_type === 'video'"
              >
                <source :src="fileUrl" type="video/mp4" />
              </video>
            </div>

            <!-- If fileUrl is not an image, show the repost card for other content -->
            <GlocalRepostCard
              v-else
              :feedObject="
                viewFeed?.content_type === 'share'
                  ? feedObject?.shared
                  : feedObject
              "
              :isCommentView="true"
            />
          </div>
        </a-col>
        <a-col 
          :xs="24"
          :sm="24"
          :md="viewFeed?.content_type === 'image' || viewFeed?.content_type === 'video' || viewFeed?.content_type === 'article' || viewFeed?.content_type === 'share' && !isSharedContentTypeText ? 10 : 24"
          :lg="viewFeed?.content_type === 'image' || viewFeed?.content_type === 'video' || viewFeed?.content_type === 'article' || viewFeed?.content_type === 'share' && !isSharedContentTypeText ? 9 : 24"
          :xl="viewFeed?.content_type === 'image' || viewFeed?.content_type === 'video' || viewFeed?.content_type === 'article' || viewFeed?.content_type === 'share' && !isSharedContentTypeText ? 9 : 24"
        >
          <div class="view-feed-modal-container__right-container">
            <div class="view-feed-modal-container__right-container--header">
              <div
                class="view-feed-modal-container__right-container--header--user"
              >
                <div
                  class="view-feed-modal-container__right-container--header--user__image"
                >
                  <img :src="viewFeed?.user?.profile_picture" alt="Image" />
                </div>
                <div
                  class="view-feed-modal-container__right-container--header--user__details"
                >
                  <h1>{{ viewFeed?.user?.full_name }}</h1>
                  <!-- <p>Frontend Developer at Devroute</p> -->
                  <p class="time">{{ viewFeed?.created_at }}</p>
                </div>
              </div>
            </div>
            <div class="view-feed-modal-container__right-container--body">
              <div class="view-feed-modal-container__right-container--body--description" v-if="hasTextContent">
                <p
                  ref="descriptionRef"
                  :class="[
                    'view-feed-modal-container__right-container--body--description--text',
                    { 'view-feed-modal-container__right-container--body--description--clamp-4-lines': !expanded }
                  ]"
                  v-html="description"
                ></p>
                <button
                  v-if="isOverflowing"
                  @click="expanded = !expanded"
                  class="view-feed-modal-container__right-container--body--description--see-more-button"
                >
                  {{ expanded ? 'See Less' : 'See More' }}
                </button>
              </div>
              <GlocalRepostCard
                v-if="viewFeed?.content_type === 'share' && viewFeed?.shared?.content_type === 'text'"
                :feedObject="
                  viewFeed?.content_type === 'share'
                    ? feedObject?.shared
                    : feedObject
                "
                :isCommentView="false"
              />
              
              <div
                :class="[
                  'view-feed-modal-container__right-container--body--footer',
                  { 'p-5': description.length < 10 }
                ]"
              >
                <the-reaction-badge-counter
                  v-if="
                    feedObject?.feed_reactions &&
                      Object.keys(feedObject.feed_reactions).length > 0
                  "
                  :totalArticleReactions="feedObject?.feed_reactions"
                  :userReactionRepresentation="
                    feedObject?.users_reaction_representation
                  "
                  :articleId="feedObject?.id"
                  :feedTotalComments="feedObject?.total_comments ?? 0"
                >
                </the-reaction-badge-counter>
                <div class="action-bar">
                  <the-reactions
                    :articleId="viewFeed.id"
                    :userReaction="viewFeed.user_reaction"
                    @updateReaction="updateReaction"
                  ></the-reactions>
                  <span class="action-bar__line"></span>
                  <button class="action-bar__btn">
                    <img
                      src="@/assets/icons/comment-icon.png"
                      style="width: 2rem; object-fit: contain;"
                    />
                    Comment
                  </button>
                  <span class="action-bar__line"></span>
                  <button
                    class="action-bar__btn"
                    @click="toggleShareFeedModal()"
                  >
                    <img
                      src="@/assets/icons/reply.svg"
                      style="width: 1.8rem;"
                    />
                    Share
                  </button>
                </div>
                <div class="comment-type-input">
                  <feed-comment-input
                    @create="createComment"
                    :loadingState="commentLoader"
                  ></feed-comment-input>
                </div>
                <template v-if="fetchCommentLoader">
                  <comments-skeleton
                    v-for="commentSkeleton in 2"
                    :key="commentSkeleton"
                  />
                </template>
                <template v-else>
                  <feed-comments
                    :feedId="feedObject.id"
                    v-for="feedCommentId in feedCommentsIdArray"
                    :key="feedCommentId"
                    :feedComment="feedComments.get(feedCommentId)"
                  />
                </template>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
  </a-modal>

  <ShareFeedModal
    :visible="openShareModal"
    @closeShareModal="toggleShareFeedModal"
    :feed="feedObject"
  />
</template>

<script>
import TheReactions from "../BaseComponents/TheReactions.vue";
import TheReactionBadgeCounter from "../BaseComponents/TheReactionBadgeCounter.vue";
import FeedComments from "./FeedComments.vue";
import GlocalRepostCard from "./GlocalRepostCard.vue";
import { mapGetters, mapActions } from "vuex";
import FeedCommentInput from "./FeedCommentInput.vue";
import CommentsSkeleton from "../BaseComponents/CommentsSkeleton.vue";
import ShareFeedModal from "./ShareFeedModal.vue";

export default {
  name: "ViewFeedModal", 
  data() {
    return {
      reRender: 0,
      commentLoader: false,
      fetchCommentLoader: false,
      openShareModal: false,
      expanded: false,
      isOverflowing: false
    };
  },
  components: {
    TheReactions,
    TheReactionBadgeCounter,
    FeedComments,
    GlocalRepostCard,
    FeedCommentInput,
    CommentsSkeleton,
    ShareFeedModal,
  },
  emits:['closeViewFeedModal'],
  props: {
    visible: Boolean,
    viewFeed: Object,
    feedObject: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters({
      userId: "auth/getUserId",
      feedComments: "feed/feedComments",
      feedCommentsIdArray: "feed/feedCommentsIdArray",
    }),
    fileUrl() {
      const source =
        this.viewFeed?.content_type === "share"
          ? this.feedObject?.shared
          : this.feedObject;

      return source?.files?.length > 0 ? source.files[0].file : null;
    },
    description() {
      return this.feedObject?.text || "";
    },
    isSharedContentTypeText(){
      return  this.viewFeed?.content_type === "share" ? this.viewFeed?.shared?.content_type === 'text' ?  true : false : false
    },
    hasTextContent() {
      const div = document.createElement('div');
      div.innerHTML = this.feedObject.text || '';
      return div.textContent.trim().length > 0;
    }
  },
  mounted() {
    this.checkOverflow();
  },
  watch: {
    visible: {
      async handler(newVal, oldVal) {
        if (newVal) {
          this.fetchCommentLoader = !this.fetchCommentLoader;
          await this.fetchComments({ postId: this.feedObject?.id });
          this.fetchCommentLoader = !this.fetchCommentLoader;
        }
        if (newVal) {
          this.$nextTick(() => {
            this.checkOverflow();
          });
        }
      },
      immediate: true,
    },
    'feedObject.text'(newVal) {
      this.$nextTick(() => {
        this.expanded = false;
        this.checkOverflow();
      });
    }
  },
  methods: {
    ...mapActions({
      fetchComments: "feed/fetchComments",
      createFeedComments: "feed/createFeedComments",
      // userId: "auth/getUserId",
      fetchActivity: "feed/fetchActivity",
      updateActivityOrCommentPageLimit: "feed/updateActivityOrCommentPageLimit",
      resetActivityOrCommentPageCounter: "feed/resetActivityOrCommentPageCounter",
    }),
    closeModal() {
      this.$emit("closeViewFeedModal", false);
    },
    updateReaction() {
      this.reRender = this.reRender + 1;
    },
    async createComment(comment) {
      try {
        const payload = {
          user: this.userId,
          text: comment,
          parent: null,
        };
        this.commentLoader = !this.commentLoader;
        await this.createFeedComments({ postId: this.feedObject?.id, payload });
        await this.fetchCommentsActivity()
      } catch (err) {
        console.log(err);
      } finally {
        this.commentLoader = !this.commentLoader;
      }
    },
    toggleShareFeedModal() {
      this.openShareModal = !this.openShareModal;
    },
    isImage(url) {
      const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
      const extension = url
        .split(".")
        .pop()
        .toLowerCase();
      return imageExtensions.includes(extension);
    },
    checkOverflow() {
      this.$nextTick(() => {
        const el = this.$refs.descriptionRef;
        if (el) {
          const overflow = el.scrollHeight > el.clientHeight + 1;
          this.isOverflowing = overflow;
        }
      });
    },
    async fetchCommentsActivity(){
      this.updateActivityOrCommentPageLimit({type:'comment', limit:'remaining'})
      this.resetActivityOrCommentPageCounter({type:'comment'})
      await this.fetchActivity({type:'comment'})
    },
  },
};
</script>
<style lang="scss">
.view-feed-modal {
  width: 95vw !important;
  top: 7.5rem !important;
  padding: 0 4rem;
  max-width: 150rem !important;

  .ant-modal-content {
    box-shadow: 0px 0px 94px #00000047;

    .ant-modal-close {
      margin: 1.5rem 1.5rem 0 0;
      .ant-modal-close-x {
        padding: 0.5rem;
        width: 4rem;
        height: 3.8rem;
        line-height: normal;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: $color-white;
        .anticon {
          color: $color-black;
          font-size: 2rem;
        }
      }
      @include respond(tab-port) {
        margin: 0;
        .ant-modal-close-x {
          padding: 1rem !important;
          border-start-end-radius: 1rem !important;
          .anticon {
            font-size: 2.2rem;
          }
        }
      }
    }

    .ant-modal-body {
      .ant-row {
        .ant-col-md-24 {
          .view-feed-modal-container {
            &__right-container {
              &--body {
                &--footer {
                  padding-top: 0;
                }
              }
            }
          }
        }
      }
      .view-feed-modal-container {
        height: calc(100vh - 13rem);
        overflow-y: hidden;
        overflow-x: hidden;
        @include respond(tab-port) {
          overflow-y: auto;
          height: calc(100vh - 15rem);
          &::-webkit-scrollbar {
            display: none;
          }
        }
        &__left-container {
          height: calc(100vh - 13rem);
          overflow-y: auto;
          display: inline-flex;
          width: 100%;
          background-color: $color-black;
          border-start-start-radius: 1rem;
          border-end-start-radius: 1rem;
          &::-webkit-scrollbar {
            width: 0.2rem;
            height: 0.2rem;
          }

          &::-webkit-scrollbar-track {
            background-color: $color-white;
            border-radius: 0.8rem;
          }

          &::-webkit-scrollbar-thumb {
            background-color: $color-primary;
            border-radius: 0.8rem;
          }
          @include respond(tab-port) {
            height: auto;
            overflow-y: hidden;
            border-end-start-radius: 0;
            border-start-end-radius: 1rem;
          }
          &--media {
            border-start-start-radius: 1rem;
            border-end-start-radius: 1rem;
            width: 100%;
            display: inline-flex;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              display: block;
              margin: auto;
            }
            video {
              width: 100%;
              max-width: 51rem;
              margin: auto;
              min-height: 100%;
              max-height: auto;
            }
          }
          .glocal-repost-card {
            max-width: 100%;
            margin: auto;
            width: 100%;
            border: none;
            border-radius: 0;
            border-start-start-radius: 1rem;
            .upload-image {
              height: calc(100vh - 13rem);
              overflow: hidden;
              background-color: $color-black;
              @include respond(tab-port) {
                height: calc(100vh - 32rem);
              }
            }
            &__body {
              height: 100%;
              .upload-article {
                &__header {
                  padding: 3.6rem 2rem;
                  height: 46rem;
                  border-start-start-radius: 1rem;
                  background-size: cover;
                  @include respond(tab-port) {
                    border-start-end-radius: 1rem;
                    height: 34rem;
                  }
                  &--auth-and-date {
                    font-size: 1.6rem;
                  }
                }
                &__body {
                  padding: 2.5rem 2rem;
                  @include respond(tab-port) {
                    padding-bottom: 1rem;
                  }
                  &--description {
                    opacity: 1;
                    p {
                      display: block;
                      -webkit-line-clamp: unset;
                      font-size: 1.8rem;
                      line-height: 2.8rem;
                      @include respond(tab-port) {
                        display: -webkit-box;
                        -webkit-line-clamp: 4;
                        line-clamp: 4;
                      }
                    }
                  }
                }
              }
              .upload-file {
                height: calc(100vh - 13rem);
                overflow: hidden;
                @include respond(tab-port) {
                  height: calc(100vh - 32rem);
                }
              }
              .upload-video {
                height: calc(100vh - 13rem);
                overflow: hidden;
                background-color: $color-black;
                border-end-start-radius: 1rem;
                @include respond(tab-port) {
                  height: calc(100vh - 33rem);
                  border-radius: 0;
                }
              }
            }
          }
        }
        &__right-container {
          border-left: 1px solid $color-dark-grey-5;
          @include respond(tab-port) {
            border-left: 0;
          }
          &--header {
            padding: 2rem 2rem 1.5rem;
            position: sticky;
            top: 0;
            background-color: $color-white;
            border-start-end-radius: 1rem;
            border-start-start-radius: 1rem;
            &--user {
              display: flex;
              justify-content: flex-start;
              align-items: center;

              &__image {
                width: 5rem;
                height: 5rem;
                margin-right: 1rem;
                cursor: pointer;
                border-radius: 100%;

                img {
                  width: 100%;
                  height: auto;
                  border-radius: 100%;
                  object-fit: contain;
                  background-color: #ebebeb;
                }
              }

              &__details {
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                h1 {
                  font-size: 1.8rem;
                  font-family: $font-primary-bold;
                  line-height: 2.4rem;
                  margin-bottom: 0.3rem;
                  color: $color-black;
                  cursor: pointer;
                }

                p {
                  font-size: 1.4rem;
                  color: $color-black;
                  opacity: 0.6;
                  font-family: $font-primary-medium;
                  margin-bottom: 0;
                  line-height: 1.7rem;
                }

                .time {
                  font-size: 1.2rem;
                  line-height: 1.5rem;
                }
              }
              @include respond(phone-x-small) {
                &__details {
                  h1 {
                    font-size: 2rem;
                    line-height: 2.6rem;
                  }
                  .time {
                    font-size: 1.6rem;
                    line-height: 2.2rem;
                  }
                }
              }
            }
          }
          &--body {
            height: calc(100vh - 21.5rem);
            overflow-y: auto;
            overflow-x: hidden;
            @include respond(tab-port) {
              height: 100%;
              overflow-y: hidden;
            }
            &::-webkit-scrollbar {
              width: 0.2rem;
              height: 0.2rem;
            }

            &::-webkit-scrollbar-track {
              background-color: transparent;
              border-radius: 0.8rem;
            }

            &::-webkit-scrollbar-thumb {
              background-color: $color-primary;
              border-radius: 0.8rem;
            }
            &--description {
              padding: 0 2rem 1.5rem;
              &--text {
                font-size: 1.4rem;
                font-family: $font-primary;
                line-height: 2rem;
                margin-bottom: 0;
                color: $color-black;
                p, h1, h2, h3, h4, h5, h6, a {
                  font-size: inherit;
                  margin-bottom: 0;
                }
                a {
                  color: $color-links;
                }
              }
              @include respond(phone-x-small) {
                &--text {
                  font-size: 1.8rem;
                  line-height: 2.6rem;
                }
              }
              &--clamp-4-lines {
                display: -webkit-box;
                -webkit-line-clamp: 4;
                -webkit-box-orient: vertical;
                overflow: hidden;
              }
              &--see-more-button {
                background: transparent;
                color: $color-links;
                font-family: $font-primary-medium;
                border: none;
                outline: none;
                font-size: 1.4rem;
                line-height: normal;
                padding: 0;
                cursor: pointer;
                margin-top: 0.5rem;
                @include respond(phone-x-small) {
                  font-size: 2rem;
                }
              }
            }
            .glocal-repost-card {
              margin: 0 2rem 2.5rem;
            }
            &--footer {
              padding-top: 1rem;
              .user-react {
                padding: 1rem 1.5rem;
                border-top: 1px solid rgba(0, 0, 0, 0.2);
                width: calc(100% - 4rem);
                margin: 0 2rem;
                @include respond(phone-x-small) {
                  padding: 1.5rem 2rem;
                  &__outer-flex {
                    &--image-conatiner {
                      .image {
                        height: 2rem;
                        width: 2rem;
                        margin-left: -0.7rem;
                      }
                    }
                  }
                  &__name {
                    font-size: 1.6rem;
                    line-height: 2.2rem;
                  }
                }
              }
              .action-bar {
                border-top: 1px solid $color-dark-grey-5;
                border-bottom: 1px solid $color-dark-grey-5;
                display: flex;
                align-items: center;
                width: calc(100% - 4rem);
                margin: 0 2rem;
                @include respond(tab-port) {
                  border-bottom: none;
                }
                &__btn {
                  width: 33.3%;
                  border: none;
                  outline: none;
                  font-size: 1.6rem;
                  font-family: $font-primary-medium;
                  line-height: normal;
                  gap: 1rem;
                  color: $color-black;
                  display: flex;
                  align-items: stretch;
                  justify-content: center;
                  cursor: pointer;
                  background-color: transparent;
                  padding: 1.5rem 0;
                  @include respond(phone-x-small) {
                    padding: 1.7rem 0;
                  }
                }

                &__line {
                  width: 1px;
                  height: 2.3rem;
                  background-color: $color-dark-grey-5;
                  display: block;
                }

                .the-horizontal-reactions-bar {
                  width: 33%;
                  padding: 0;
                  margin: 0 !important;

                  &__reaction-status {
                    padding: 1.4rem 0;
                    border-end-start-radius: 2rem;
                    @include respond(phone-x-small) {
                      padding: 1.2rem 0;
                    }
                    &--reactions {
                      .image {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        img {
                          width: 2rem !important;
                        }
                      }

                      .title {
                        font-size: 1.6rem;
                        font-family: $font-primary-medium;
                        line-height: normal;
                      }
                    }
                  }
                }
              }
              .comment-type-input {
                padding: 1rem 2rem 2rem;
              }
            }
            .p-5 {
              padding-top: 5rem;
            }
          }
        }
      }
    }
  }
}
.link-only-modal {
  max-width: 65rem !important;
  width: 100% !important;
  .ant-modal-content {
    .ant-modal-body {
      .view-feed-modal-container {
          height: auto;
          overflow: hidden;
          &__right-container {
            border-left: none;
            &--body {
              max-height: calc(100vh - 21.5rem);
              height: max-content;
            }
          }
        }
    }
  }
}
</style>
